import {
  TAX_ID_BY_COUNTRY_MAP,
  TAX_ID_VARIANTS,
  VAT_ID_BY_COUNTRY_MAP,
  TAX_INFORMATION_META,
  TAX_INFORMATION_STATUSES,
} from "./tax-information.constants";

/**
 * Remove non-alphanumeric characters
 * @param {string} str string to process -> required
 * @returns {string} the same string without special characters -> required
 */
const removeNonAlphanumeric = (str = "") => {
  return str.replace(/[^\p{L}\p{N}]/gu, "");
};

/**
 * Get tax information meta by id
 * @param {string} id vat id to get from the list -> required
 * @returns {{
 *     type: string,
 *     shortNameMessageDescriptor: string,
 *     nameMessageDescriptor: string,
 *     fullNameMessageDescriptor: string,
 *     validationFn: function,
 *     format: string,
 *     foformatStringMessageDescriptormat: string,
 *     getInputProps: function
 * }} meta object with information about tax/vat -> required
 */
const getTaxInformationMetaById = (id) => {
  const meta = TAX_INFORMATION_META[id];

  if (!meta) {
    // Improve console error description if type is missing
    throw new Error(`[TaxInformationSection] No meta for id "${id}"`);
  }

  return meta;
};

/**
 * Get tax status by account's information
 * @param {object} account user's account object -> required
 * @returns {string/null} status of tax number record -> required
 */
const getTaxStatusByAccountDetails = (account) => {
  if (account?.business_type === TAX_ID_VARIANTS.INDIVIDUAL) {
    return account?.individual?.id_number_provided
      ? TAX_INFORMATION_STATUSES.SAVED
      : TAX_INFORMATION_STATUSES.REQUIRED;
  }
  return account?.company?.tax_id_provided
    ? TAX_INFORMATION_STATUSES.SAVED
    : TAX_INFORMATION_STATUSES.REQUIRED;
};

/**
 * Get vat status by account's information
 * @param {object} account user's account object -> required
 * @returns {string/null} status of vat number record -> required
 */
const getVatStatusByAccountDetails = (account) => {
  if (account?.business_type === TAX_ID_VARIANTS.INDIVIDUAL) {
    return null;
  }
  return account?.company?.vat_id_provided
    ? TAX_INFORMATION_STATUSES.SAVED
    : TAX_INFORMATION_STATUSES.NOT_SAVED;
};

/**
 * Get tax information variant by account's requirements
 * @param {string} country user's country -> required
 * @param {string} variant user's tax variant ('individual' or 'business') -> required
 * @returns {string/null} type of tax for particular user -> required
 */
const getTaxIdByCountryAndVariant = (country, variant) => {
  if (!country || !variant) {
    return null;
  }

  const typeByCountry = TAX_ID_BY_COUNTRY_MAP[country];

  if (!typeByCountry) {
    return null;
  }

  return typeByCountry[variant] ?? null;
};

/**
 * Get tax information variant by account's requirements
 * @param {string} country user's country -> required
 * @returns {string/null} vat id for particular user -> required
 */
const getVatIdByCountry = (country) => {
  if (!country) {
    return null;
  }

  return VAT_ID_BY_COUNTRY_MAP[country] ?? null;
};

export {
  removeNonAlphanumeric,
  getTaxStatusByAccountDetails,
  getVatStatusByAccountDetails,
  getTaxIdByCountryAndVariant,
  getTaxInformationMetaById,
  getVatIdByCountry,
};
